import { AbstractControl } from '@angular/forms';
import { PhoneService } from '../services/utils/phone.service';
export function ValidatePhoneOrEmail(form: AbstractControl): any {
  const phone = form.get('contactPhone').value;
  const email = form.get('contactEmail').value;
  const errorsMail = { PhoneOrMailRequired: true, emailIsInvalid: true };
  const isEmailMaybe = require('is-email-maybe');
  const phoneService = new PhoneService();
  errorsMail.emailIsInvalid = ((email !== null && email !== '') && !isEmailMaybe(email)) ? true : null;

  if ((phone === null || phone === '') && (email === null || email === '')) {
    errorsMail.PhoneOrMailRequired = true;
    form.get('contactPhone')
      .setErrors({ PhoneOrMailRequired: true });
  } else {
    if (!phoneService.phoneIsValid(phone)) {
      errorsMail.PhoneOrMailRequired = true;
      form.get('contactPhone')
        .setErrors({ InvalidPhone: true });

    } else {
      form.get('contactPhone')
        .setErrors({ PhoneOrMailRequired: null });
    }
    errorsMail.PhoneOrMailRequired = null;
  }

  if ((phone === null || phone === '') && (email !== null && email !== '' && isEmailMaybe(email))) {
    form.get('contactPhone')
      .setErrors({ PhoneOrMailRequired: null });
  }

  form.get('contactEmail')
    .setErrors(errorsMail);
}
